import type { TraceErrorObject } from "owa-analytics-types";
import { owaTrustedTypesPolicy } from "owa-content-security-policies/lib/trustedTypesPolicies/owaTrustedTypesPolicy";

let loadedScriptsCallbacks: {
    [id: string]: Promise<void>;
} = {};

let successfulLoadedScripts: string[] | undefined;

export function loadScript(url: string, addCrossOriginAnonymous = true): Promise<void> {
    if (!loadedScriptsCallbacks[url] ||
        !successfulLoadedScripts ||
        successfulLoadedScripts.indexOf(url) == -1) {
        loadedScriptsCallbacks[url] = new Promise((resolve, reject) => {
            var element = window.document.createElement("script");
            element.src = (owaTrustedTypesPolicy?.createScriptURL(url) as unknown as string) ?? url;
            element.type = "text/javascript";
            if (addCrossOriginAnonymous) {
                element.crossOrigin = "anonymous";
            }
            element.onload = () => {
                successfulLoadedScripts
                    ? successfulLoadedScripts.push(url)
                    : (successfulLoadedScripts = [url]);
                resolve();
            };
            element.onerror = event => {
                const errorEvent = event as ErrorEvent;
                const message = errorEvent.message || errorEvent.type || "unknown";
                const err: TraceErrorObject = new Error("AdsScript load error");
                err.additionalInfo = { url, message };
                reject(err);
            };
            window.document.head.appendChild(element);
        });
    }
    
    return loadedScriptsCallbacks[url];
}

export function test_clearScriptLoadTestHook(): void {
    loadedScriptsCallbacks = {};
    successfulLoadedScripts = undefined;
}
